<nz-layout class="min-100vh">

  <!-- SIDEBAR -->
  <nz-sider nzCollapsible [(nzCollapsed)]="dataTransformService.isSidebarCollapsed" [nzTrigger]="triggerTemplate" class="menu-main" [nzWidth]="240">
    <!-- [nzLoading]="multiLingualService.defaultLanguageLoaded" -->
    <!-- <nz-skeleton nzLoading = "true" [nzActive]="multiLingualService.defaultLanguageLoaded"> -->
    <div class="menu-container"
      [ngClass]="{'menu-expanded':!dataTransformService.isSidebarCollapsed, 'menu-collapsed':dataTransformService.isSidebarCollapsed ,'searching':searchMenuTerm }">
      <div class="logo">
        <!--<div style="text-align: center">
              <h4 style="color:#FFF" *ngIf="!dataTransformService.isSidebarCollapsed">{{organizationMetaData.displayName | translate}}</h4>
              <h4 style="color:#FFF" *ngIf="dataTransformService.isSidebarCollapsed">{{organizationMetaData.organizationCd | translate}}</h4>
            </div>-->
        <div style="text-align: center">
          <h4 style="color:#FFF" *ngIf="!dataTransformService.isSidebarCollapsed"><img src="/assets/images/logos/logo-light-full.png" alt="" /></h4>
          <h4 style="color:#FFF" *ngIf="dataTransformService.isSidebarCollapsed"><img src="/assets/images/logos/logo-light-collapsed.png" alt="" />
          </h4>
        </div>
      </div>
      <!--<nz-switch [(ngModel)]="mode"></nz-switch>-->
      <ul *ngIf="true" nz-menu [nzMode]="mode?'vertical':'inline'" [nzTheme]="'dark'" [nzInlineCollapsed]="dataTransformService.isSidebarCollapsed"
        style="max-height: 90vh;overflow-y: auto;padding-bottom: 20px;">

        <!-- Search menu feature -->
        <div class="search-menu-filter" [ngClass]="{'ani ani-all-025-ease':false}">
          <div class="search-menu-input">
            <nz-input-group [nzSuffix]="suffixTemplate" [nzPrefix]="prefixTemplate">
              <input type="text" nz-input placeholder="Search ..." [(ngModel)]="searchMenuTerm" size="small"
                (ngModelChange)="filterMenu()">
            </nz-input-group>
            <ng-template #prefixTemplate><i nz-icon nzType="search"></i></ng-template>
            <ng-template #suffixTemplate><i nz-icon nzType="close-circle" (click)="searchMenuTerm=null"
                *ngIf="searchMenuTerm"></i></ng-template>
          </div>
        </div>


        <ul *ngIf="searchMenuTerm" (click)="searchMenuAutoClose();">
          <ng-container *ngIf="filteredMenu">
            <li *ngFor="let menu of filteredMenu" [routerLink]="menu.menu ? menu.menu.route : menu.route" nz-menu-item
              nz-tooltip nzPlacement="right">
              <span>
                <i nz-icon [nzType]="menu.menu ? menu.menu.icon : menu.icon" nzTheme="outline"></i>
                <span>{{menu.menu ? menu.menu.menuName : menu.menuName}}</span>
              </span>
            </li>
          </ng-container>
        </ul>
        <!-- Search End -->
        <div *ngIf="!searchMenuTerm">
          <ng-container *ngFor="let item of menuList">
            <!-- Single Level Menu -->
            <!-- {{item.menu | json}} -->
            <li *ngIf="item.menu.submenu && item.menu.submenu.length == 0" [routerLink]="item.menu.route"
              routerLinkActive="ant-menu-item-selected" nz-menu-item nz-tooltip nzPlacement="right" [id]="'menu-' + item.menu.menuName"
              [nzTitle]="item.menu.menuName | translate">
              <span title>
                <i nz-icon [nzType]="item.menu.icon" nzTheme="outline"></i>
                <span>{{item.menu.menuName | MMSTranslate}}</span>
              </span>
            </li>
            <!-- Nested Menu Items -->
            <ng-container *ngIf="item.menu.submenu &&  item.menu.submenu.length != 0">
              <!-- Without Indentation -->
              <li *ngIf="!appMetadataHandler.featureFlags.menuIndentation" nz-submenu>
                <span title>
                  <i nz-icon [nzType]="item.menu.icon"></i>
                  <span>{{item.menu.menuName | MMSTranslate}}</span>
                </span>
                <ul>
                  <li *ngFor="let submenu of item.menu.submenu" [routerLink]="submenu.route" nz-menu-item>
                    {{submenu.menuName | MMSTranslate}}
                  </li>
                </ul>
              </li>

              <!-- With Indentation -->
              <ul *ngIf="appMetadataHandler.featureFlags.menuIndentation">
                <li nz-submenu [nzIcon]="item.menu.icon" [nzTitle]="item.menu.menuName | translate">
                  <ul nz-menu-group *ngIf="item.menu.submenu">
                    <li *ngFor="let submenu of item.menu.submenu" [routerLink]="submenu.route" nz-menu-item>
                      {{submenu.menuName | MMSTranslate}}
                    </li>
                  </ul>
                </li>
              </ul>
            </ng-container>
          </ng-container>
        </div>
      </ul>
    </div>
    <!-- </nz-skeleton> -->
    <!-- Version/copyright -->
    <!-- <div class="copyright">
      v 2.0.7
    </div> -->
  </nz-sider>


  <!-- App Layout (Right hand side) -->
  <nz-layout>

    <!--  USER HEADER -->
    <nz-header style="background: #fff; padding:0;" class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center">

      <i class="trigger" nz-icon [nzType]="dataTransformService.isSidebarCollapsed?'menu-unfold':'menu-fold'" (click)="dataTransformService.isSidebarCollapsed=!dataTransformService.isSidebarCollapsed"></i>

      <div class="p-r-10 flex-inline flex-horiz-space-bw flex-vert-center user-menu-items">
        <!--
          <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon"
             nz-tooltip nzTitle="My Notes" nzPlacement="bottom"
          ></i>

          <i (click)="chatBot=!chatBot" nz-icon nzType="aliwangwang" nzTheme="outline" class="cur-pointer topbar-icon"
             nz-tooltip nzTitle="Chat with agent buddy" nzPlacement="bottom"
          ></i>

        <nz-badge [nzCount]="5" [routerLink]="['/app/ocr-base']">
          <nz-avatar nzIcon="anticon anticon-user" [nzShape]="'square'"></nz-avatar>
        </nz-badge>
        -->

        <div nz-popover [nzPopoverContent]="SpecificFeatures" nzPlacement="bottomRight">
          <label *ngIf="env['demo']" nz-checkbox
            [(ngModel)]="appMetadataHandler.featureFlags['enableBetaFeatures']">Beta
            Features</label>
          <ng-template #SpecificFeatures>
            <div class="notif-popover">
              <a (click)="enableSpecificFeatures = !enableSpecificFeatures">Enable Specific Features</a>
            </div>
          </ng-template>
        </div>

        <!-- <nz-radio-group [(ngModel)]="language" (ngModelChange)="changeLanguage(language)" [nzButtonStyle]="'solid'"
          [nzSize]="'small'" class="m-r-10">
          <label *ngFor="let locale of multiLingualService.listOfLocales" nz-radio-button
            [nzValue]="locale.languageCd"><span>{{locale.languageCd}}</span></label>
          <label *ngIf="appMetadataHandler.localLocaleAllowed" nz-radio-button nzValue="en-US"><span>enUS</span></label>
          <label *ngIf="appMetadataHandler.localLocaleAllowed" nz-radio-button nzValue="in-BH"><span>inBH</span></label>
        </nz-radio-group> -->
        <!-- Notif -->
        <nz-badge *ngIf="appMetadataHandler.featureFlags.enableNotification" [nzCount]="5" class="m-r-10">
          <i nz-icon nzType="bell" nzTheme="outline" class="cur-pointer topbar-icon" nz-tooltip nzTitle="Notifications"
            nzPlacement="bottom"></i>
        </nz-badge>
        <!-- ChatBot -->
        <i *ngIf="appMetadataHandler.featureFlags.enableChat" (click)="chatBot=!chatBot" nz-icon nzType="aliwangwang"
          nzTheme="outline" class="cur-pointer topbar-icon m-r-10" nz-tooltip nzTitle="Chat with agent buddy"
          nzPlacement="bottom"></i>
        <!-- API Log -->
        <i *ngIf="env['showAPIlog']" (click)="URLCallLogModal=!URLCallLogModal" nz-icon nzType="cluster" nzTheme="outline"
          class="cur-pointer topbar-icon m-r-10" nz-tooltip nzTitle="Check API Log" nzPlacement="bottom"></i>

        <!-- User Profile -->
        <!--
        <div class="flex flex-both-center">
          <nz-avatar nzIcon="anticon anticon-user" [nzShape]="'square'"></nz-avatar>
          <span class="d-b m-l-r-10 col-grey-dark">
            <b title="{{userInfoSrvc.getUserId()}}">Hi, {{userInfoSrvc.getUserName()}}</b>
          </span>
        </div>
         -->

        <!-- User Profile -->
        <span class="p-profile">
          <!-- Avatar -->
          <nz-avatar nzIcon="user" [nzShape]="'square'" style="border: 1px solid #ccc;border-radius: 3px;"></nz-avatar>
          <!-- User Data -->
          <a style="color: #7e8890" nz-dropdown [nzDropdownMenu]="menu">
            <div class="user-profile-navbar">
              <span class="grid p-r-5">
                <span class="p-profile-name">Hi, {{userInfoSrvc.getUserName()}}</span>
                <span class="p-profile-sub" [title]="userInfoSrvc.getUserId()">
                  Role
                </span>
              </span>
              <i nz-icon nzType="down"></i>
            </div>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu [nzSelectable]="false">
              <!--<li nz-menu-item>
                  <a [routerLink]="'/app/profile-edit'">Edit Profile</a>
            </li>-->
              <li nz-menu-item>
                <a (click)="logout()">Logout</a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </span>

      </div>

    </nz-header>

    <nz-content class="app-content-spacer">
      <!-- <nz-skeleton nzLoading = "true" [nzActive]="multiLingualService.defaultLanguageLoaded"> -->

      <nz-breadcrumb style="margin:15px 0;" [nzAutoGenerate]="true">
        <nz-breadcrumb-item><i nz-icon nzType="home"></i></nz-breadcrumb-item>
        <!--<nz-breadcrumb-item><a><i nz-icon nzType="bar-chart"></i><span> App</span></a></nz-breadcrumb-item>-->
      </nz-breadcrumb>

      <div class="main-content">
        <!-- Primary Outlet -->
        <router-outlet></router-outlet>
        <!-- / Primary Outlet -->
      </div>
      <!-- </nz-skeleton> -->
    </nz-content>

    <!-- FOOTER -->
    <nz-footer class="text-a-center">&copy; 2018 MetaMorphoSys &bull; All rights reserved </nz-footer>
    <ng-template #trigger>
      <i nz-icon nzType="up"></i>
    </ng-template>


  </nz-layout>

</nz-layout>

<nz-layout *ngIf="false" class="min-100vh">
  <nz-sider nzCollapsible [(nzCollapsed)]="dataTransformService.isSidebarCollapsed" [nzTrigger]="triggerTemplate" class="menu-main">
    <div class="logo">
      <div style="text-align: center">
        <h4 style="color:#FFF" *ngIf="!dataTransformService.isSidebarCollapsed"><img src="/assets/images/logos/logo-light-full.png" alt="" /></h4>
        <h4 style="color:#FFF" *ngIf="dataTransformService.isSidebarCollapsed"><img src="/assets/images/logos/logo-light-collapsed.png" alt="" />
        </h4>
      </div>
    </div>

    <ul *ngIf="searchMenuTerm" (click)="searchMenuAutoClose();">
      <ng-container *ngIf="filteredMenu">
        <li *ngFor="let menu of filteredMenu" [routerLink]="menu.menu ? menu.menu.route : menu.route" nz-menu-item
          nz-tooltip nzTooltipPlacement="right">
          <span>
            <i nz-icon [nzType]="menu.menu ? menu.menu.icon : menu.icon" nzTheme="outline"></i>
            <span>{{menu.menu ? menu.menu.menuName : menu.menuName}}</span>
          </span>
        </li>
      </ng-container>
    </ul>

    <!-- <ul *ngIf="!searchMenuTerm" nz-menu nzTheme="dark" nzMode="inline">
      <li nz-submenu nzTitle="User" nzIcon="user">
        <ul>
          <li *ngFor="let item of menuList" nz-menu-item>Tom</li>
          <li nz-menu-item>Bill</li>
          <li nz-menu-item>Alex</li>
        </ul>
      </li>
      <li nz-submenu nzTitle="Team" nzIcon="team">
        <ul>
          <li nz-menu-item>Team 1</li>
          <li nz-menu-item>Team 2</li>
        </ul>
      </li>
      <li nz-menu-item>
        <i nz-icon nzType="file"></i>
        <span>File</span>
      </li>
    </ul> -->
    <ul *ngIf="!searchMenuTerm">
      <ng-container *ngFor="let item of menuList">
        <!-- Single Level Menu -->
        <li *ngIf="item.menu.submenu.length == 0 && item.menu.isWorking == true" [routerLink]="item.menu.route"
          routerLinkActive="ant-menu-item-selected" nz-menu-item nz-tooltip nzTooltipPlacement="right"
          [nzTooltipTitle]="item.menu.menuName | translate">
          <span title>
            <i nz-icon [nzType]="item.menu.icon" nzTheme="outline"></i>
            <span>{{item.menu.menuName | MMSTranslate}}</span>
          </span>
        </li>
        <!-- Nested Menu Items -->
        <ng-container *ngIf="item.menu.submenu.length != 0">
          <!-- Without Indentation -->
          <li *ngIf="!appMetadataHandler.featureFlags.menuIndentation" nz-submenu>
            <span title>
              <i nz-icon [nzType]="item.menu.icon"></i>
              <span>{{item.menu.menuName | MMSTranslate}}</span>
            </span>
            <ul>
              <li *ngFor="let submenu of item.menu.submenu" [routerLink]="submenu.route" nz-menu-item>
                {{submenu.menuName | MMSTranslate}}
              </li>
            </ul>
          </li>

          <!-- With Indentation -->

          <ul *ngIf="appMetadataHandler.featureFlags.menuIndentation">

            <li *ngIf="item.menu.isWorking == true" nz-submenu [nzIcon]="item.menu.icon"
              [nzTooltipTitle]="item.menu.menuName | translate">
              <ul *ngIf="item.menu.isWorking == true">
                <li *ngFor="let submenu of item.menu.submenu" [routerLink]="submenu.route" nz-menu-item>
                  {{submenu.menuName | MMSTranslate}}
                </li>
              </ul>
            </li>
          </ul>
        </ng-container>
      </ng-container>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header style="background: #fff; padding:0;" class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center">
      <i class="trigger" nz-icon [nzType]="dataTransformService.isSidebarCollapsed ? 'menu-unfold' : 'menu-fold'"
        (click)="dataTransformService.isSidebarCollapsed = !dataTransformService.isSidebarCollapsed"></i>
      <div></div>
      <div></div>
      <div class="p-r-10 flex-inline flex-horiz-space-bw flex-vert-center user-menu-items">
        <!--
          <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon"
             nz-tooltip nzTooltipTitle="My Notes" nzTooltipPlacement="bottom"
          ></i>

          <i (click)="chatBot=!chatBot" nz-icon nzType="aliwangwang" nzTheme="outline" class="cur-pointer topbar-icon"
             nz-tooltip nzTooltipTitle="Chat with agent buddy" nzTooltipPlacement="bottom"
          ></i>

        <nz-badge [nzCount]="5" [routerLink]="['/app/ocr-base']">
          <nz-avatar nzIcon="anticon anticon-user" [nzShape]="'square'"></nz-avatar>
        </nz-badge>
        -->


        <div nz-popover [nzPopoverContent]="SpecificFeatures" nzPopoverPlacement="bottomRight">
          <label *ngIf="env['demo']" nz-checkbox
            [(ngModel)]="appMetadataHandler.featureFlags['enableBetaFeatures']">Beta
            Features</label>
          <ng-template #SpecificFeatures>
            <div class="notif-popover">
              <a (click)="enableSpecificFeatures = !enableSpecificFeatures">Enable Specific Features</a>
            </div>
          </ng-template>
        </div>

        <nz-radio-group [(ngModel)]="language" (ngModelChange)="changeLanguage(language)" [nzButtonStyle]="'solid'"
          [nzSize]="'small'" class="m-r-10">
          <label *ngFor="let locale of multiLingualService.listOfLocales" nz-radio-button
            [nzValue]="locale.languageCd"><span>{{locale.languageCd}}</span></label>
          <label *ngIf="appMetadataHandler.localLocaleAllowed" nz-radio-button nzValue="en-US"><span>enUS</span></label>
          <label *ngIf="appMetadataHandler.localLocaleAllowed" nz-radio-button nzValue="in-BH"><span>inBH</span></label>
        </nz-radio-group>
        <!-- Notif -->
        <nz-badge [nzCount]="5" class="m-r-10">
          <i nz-icon nzType="bell" nzTheme="outline" class="cur-pointer topbar-icon" nz-tooltip nzTooltipTitle="Notifications"
            nzTooltipPlacement="bottom"></i>
        </nz-badge>
        <!-- ChatBot -->
        <i *ngIf="appMetadataHandler.featureFlags.enableChat" (click)="chatBot=!chatBot" nz-icon nzType="aliwangwang"
          nzTheme="outline" class="cur-pointer topbar-icon m-r-10" nz-tooltip nzTooltipTitle="Chat with agent buddy"
          nzTooltipPlacement="bottom"></i>
        <!-- API Log -->
        <i *ngIf="env['showAPIlog']" (click)="URLCallLogModal=!URLCallLogModal" nz-icon nzType="cluster"
          nzTheme="outline" class="cur-pointer topbar-icon m-r-10" nz-tooltip nzTooltipTitle="Check API Log"
          nzTooltipPlacement="bottom"></i>

        <!-- User Profile -->
        <!--
        <div class="flex flex-both-center">
          <nz-avatar nzIcon="anticon anticon-user" [nzShape]="'square'"></nz-avatar>
          <span class="d-b m-l-r-10 col-grey-dark">
            <b title="{{userInfoSrvc.getUserId()}}">Hi, {{userInfoSrvc.getUserName()}}</b>
          </span>
        </div>
         -->

        <!-- User Profile -->
        <span class="p-profile">
          <!-- Avatar -->
          <nz-avatar nzIcon="user" [nzShape]="'square'" style="border: 1px solid #ccc;border-radius: 3px;"></nz-avatar>
          <!-- User Data -->
          <a style="color: #7e8890" nz-dropdown [nzDropdownMenu]="menu">
            <div class="user-profile-navbar">
              <span class="grid p-r-5">
                <span class="p-profile-name">Hi, {{userInfoSrvc.getUserName()}}</span>
                <span class="p-profile-sub" [title]="userInfoSrvc.getUserId()">
                  Role
                </span>
              </span>
              <i nz-icon nzType="down"></i>
            </div>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu [nzSelectable]="false">
              <!--<li nz-menu-item>
                  <a [routerLink]="'/app/profile-edit'">Edit Profile</a>
            </li>-->
              <li nz-menu-item>
                <!-- <a (click)="logout()">Logout</a> -->
                <a [routerLink]="'/login'">Logout</a>
              </li>


            </ul>
          </nz-dropdown-menu>
        </span>

      </div>
    </nz-header>
    <nz-content class="app-content-spacer">
      <nz-breadcrumb style="margin:15px 0;" [nzAutoGenerate]="false">
        <nz-breadcrumb-item>
          <a><i nz-icon nzType="home" nzTheme="outline"></i><span> / {{breadCrumb}}</span></a>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
      <div class="main-content inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <nz-footer>MetaMorphoSys Technologies ©2021 Built with ❤️ </nz-footer>
  </nz-layout>
</nz-layout>

<!-- HIDDEN -->
<nz-drawer [nzClosable]="true" [nzWidth]="410" [nzVisible]="chatBot" [nzPlacement]="'right'"
  (nzOnClose)="closeChatBot()">
  <ng-container *nzDrawerContent>
    <div class="memo-main-container">

      <div class="memo memo-container">

        <div class="memo-header-container">
          <img src="/assets/images/memo/memo-bot.png" alt="" style="height: 200px;">
          <h2 class="memo-h1">Hello! <br> I'm your buddy</h2>
          <p class="memo-subtext">And I'm here to answer your queries</p>
        </div>

        <div class="memo-messages-container">

          <div class="memo-message">
            <div class="memo-message-content">
              Hello! I am your personal digital assistant. I can help you with all your queries.
              What would you like to do?
              <ul>
                <li>See your performance</li>
                <li>Forecast sales</li>
                <li>View total commissions</li>
              </ul>
            </div>
          </div>

          <div class="memo-message">
            <div class="human memo-message-content">
              Show me my sales performance for this month
            </div>
            &nbsp;
          </div>

          <div class="memo-message">
            <div class="memo-message-content">
              Absolutely.
              <br />
              <img class="clickable" (click)="showPerformanceModal()"
                src="/assets/images/demo/agent_performance_chartgo.png" style="width:100%" alt=" ">
            </div>
          </div>

        </div>

        <div class="memo-actions-container">
          <textarea class="memo-input" name="" id="" cols="30" rows="3"></textarea>
          <button class="memo-button"></button>
        </div>
      </div>


    </div>
  </ng-container>
</nz-drawer>
<!-- Dummy Modal with Chart Image -->
<nz-modal [(nzVisible)]="perfModalisVisible" nzTitle="Your Sales Performance" (nzOnCancel)="showPerformanceModal()"
  (nzOnOk)="showPerformanceModal()">
  <ng-container *nzModalContent>
    <img src="/assets/images/demo/agent_performance_chartgo.png" style="width:100%" alt="" />
  </ng-container>
</nz-modal>

<nz-modal nzMaskClosable="false" [nzWidth]="'800'" [nzFooter]="captureCheckList" [(nzVisible)]="URLCallLogModal"
  nzTitle="API Log" (nzOnCancel)="URLCallLogModal=false" (nzOnOk)="URLCallLogModal=false" nzOkDisabled="true"
  nzOkText="Ok">
  <ng-container *nzModalContent>
    <div *ngIf="URLCallLogModal">
      <h4>API Call Log</h4>
      <a (click)="refreshAPILog()">Refresh</a> &nbsp; &nbsp; <a (click)="clearAPILog()">Clear Log</a>
      <nz-table #API [nzData]="fetchedAPILog" [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
          <tr>

            <th>API({{fetchedAPILog? fetchedAPILog.length : 0}})</th>
            <th>Count</th>

          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of API.data; let i=index">
            <tr>
              <td>{{data.url}}</td>
              <td>{{data.count}}</td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>

    </div>
  </ng-container>

</nz-modal>

<nz-modal nzMaskClosable="false" [nzWidth]="'800'" [nzFooter]="captureCheckList" [(nzVisible)]="enableSpecificFeatures"
  nzTitle="Enable Specific Features" (nzOnCancel)="enableSpecificFeatures=false" (nzOnOk)="enableSpecificFeatures=false"
  nzOkDisabled="true" nzOkText="Ok">
  <ng-container *nzModalContent>
    <div *ngIf="enableSpecificFeatures && env['demo']">
      <h4>Enable Specific Features</h4>
      <!-- <a (click)="refreshAPILog()">Refresh</a> &nbsp; &nbsp; <a (click)="clearAPILog()">Clear Log</a> -->
      <nz-table #FeatureFlags [nzData]="featureFlagsArray" [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Features</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of FeatureFlags.data; let i=index">
            <tr>
              <td>{{data.keyDescription}}</td>
              <td><label nz-checkbox [(ngModel)]="appMetadataHandler.featureFlags[data.key]">
                  {{appMetadataHandler.featureFlags[data.key]? 'Enabled':'Disabled'}}
                </label></td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>

    </div>
  </ng-container>
</nz-modal>
<!-- End Hidden -->